import { atom } from "jotai";
import { ConversationMakerSocket } from "@/core/socket";

export const socketAtom = atom<ConversationMakerSocket>();
